import { useAppSelector } from '../data/store';
import Imgix from 'react-imgix';
import React, { Fragment } from 'react';
import { getImgCDNDomain } from '../../../../domain/common';
import ArrowIcon from '../../../../ui/svg/common/arrow';
import Separator from '../../shared/separator';
import { sendGAEvent } from '../../../../domain/marketing/gtm-provider';
import { getGeneralSearchUrl } from '../domain/search-provider';

const DropPanel = () => {

    const filtered = useAppSelector(store => store.root.filtered);
    const query = useAppSelector(store => store.root.query);
    const selectedItemIndex = useAppSelector(store => store.root.selectedItemIndex);

    const imgDomain = getImgCDNDomain();

    const sendClickGAEvent = (position: number, documentUrlPath: string) => {
        // q: {query} | pos: {position} | page: {distinationURL}
        // q: api | pos: 3 | page: /plugins/api-2500
        sendGAEvent('AutoCompleteClick', `q: ${ query.toLowerCase()} | pos: ${ position  + 1} | page: ${ documentUrlPath }`);
    };

    return (
        <div className="waves-header-search-drop absolute right-0 top-full bg-white text-gray-500 shadow-md rounded px-4 py-2 text-tiny border border-gray-100">
            <p className="font-medium text-gray-700 my-2">Quick Links</p>
            <Separator />

            {
                filtered.length === 0 && (
                    <>
                        <p className="flex py-4">
                            No results found.
                            <a
                                href={ getGeneralSearchUrl(query) }
                                title=""
                                className="no-underline ml-2 font-medium">
                                Search all
                            </a>
                        </p>
                        <Separator />
                    </>
                )
            }

            {
                filtered.map((item, i) => {

                    const absImgUrl = `${ imgDomain }${ item.tiny }`;
                    const selectedClasses = selectedItemIndex === i ? 'bg-gray-150' : '';

                    return (
                        <Fragment key={ `${ item.documentName }-${ i }` }>
                            <a
                                href={ item.documentUrlPath }
                                onClick={ () => {
                                    sendClickGAEvent(i, item.documentUrlPath);
                                }}
                                className={ `flex items-center no-underline text-tiny text-gray-500 py-2 px-2 hover:bg-gray-150 ${ selectedClasses }` }>

                                <div className="mr-4">
                                    <Imgix
                                        src={ absImgUrl }
                                        width={ 140 }
                                        className="whsd__icon"
                                    />
                                </div>

                                <div>
                                    <p className="font-medium text-gray-700">{ item.documentName }</p>
                                    <p className="w-ellipsis w-line-clamp-2" dangerouslySetInnerHTML={{__html: item.documentPageDescription }} />
                                </div>
                            </a>

                            <Separator />
                        </Fragment>
                    )
                })
            }

            <p className="flex pt-4 pb-2">
                <a
                    href={ getGeneralSearchUrl(query) }
                    title=""
                    className="no-underline ml-auto font-medium flex items-center">
                    See more results
                    <ArrowIcon
                        width="8px"
                        color="#3452ff"
                        title="Arrow Right"
                        rotationAngle={ -90 }
                        classes="ml-2"
                    />
                </a>
            </p>
        </div>
    )
};

export default DropPanel;